import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

const withStateHandlersHOCGenerator = (Component) => {
  function WithStateHandlersHOC(props) {
    const { onChange, value: ownerValue } = props;
    const [dropdownDisplayed, setDropdownDisplayed] = useState(false);
    const [matches, setMatches] = useState([]);
    const [query, setQuery] = useState(null);
    const [innerValue, setInnerValue] = useState('');

    useEffect(() => {
      setInnerValue(ownerValue);
    }, [ownerValue]);

    // Handlers
    const setValue = useCallback((_value) => {
      setInnerValue(_value);
      onChange(_value);
    }, []);
    const openDropdownWithMatches = useCallback((_matches) => {
      setMatches(_matches);
      setDropdownDisplayed(true);
    }, []);
    const closeDropdownAndResetMatches = useCallback(() => {
      setMatches([]);
      setDropdownDisplayed(false);
    }, []);

    return (
      <Component
        {...props}
        dropdownDisplayed={dropdownDisplayed}
        matches={matches}
        query={query}
        value={innerValue}
        openDropdownWithMatches={openDropdownWithMatches}
        closeDropdownAndResetMatches={closeDropdownAndResetMatches}
        setQuery={setQuery}
        setValue={setValue}
      />
    );
  }

  WithStateHandlersHOC.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
  };

  return WithStateHandlersHOC;
};

const withStateHandlers = () => (Component) => withStateHandlersHOCGenerator(Component);

export default withStateHandlers;
